/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { ReactElement } from 'react';
import {
  Button,
  Card,
  CardContent,
  CardActions,
  Grid,
  Tooltip,
} from '@mui/material';
import { MdOutlineFileDownload, MdOutlineVisibility } from 'react-icons/md';
import moment from 'moment';
import { getFileIcon, getFileName } from '../../utils';
import { CandidateDocumentsViewRendererProps } from '../../types';

function DocsGridView(props: CandidateDocumentsViewRendererProps) {
  const {
    documentList,
    onDocumentDownload,
    onDocumentView,
  } = props;

  const getIcon = (fileName: string): ReactElement => {
    const Component = getFileIcon(fileName);
    return <Component className="w-10 h-10 text-secondary" />;
  };

  if (documentList.length === 0) {
    return (
      <div className="flex items-center justify-center h-full">
        No Data found
      </div>
    );
  }

  return (
    <Grid container spacing={1}>
      {documentList.map((doc) => (
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <Card key={`id-${doc.documentId}`} className="basis-1/4 custom-shadow h-full" elevation={0}>
            <CardContent className="flex flex-row pb-1">
              <div className="flex items-center">
                {getIcon(doc.documentName)}
              </div>
              <div className="pl-4 space-y-1 w-full">
                <Tooltip title={doc.documentName}>
                  <div className="text-base break-all">{getFileName(doc.documentName, 25).name}</div>
                </Tooltip>
                <div className="text-xs">{moment(doc.updatedDate).format('DD-MM-YYYY')}</div>
              </div>
            </CardContent>
            <CardActions className="flex justify-evenly pt-0 m-0">
              <Button
                size="small"
                className="text-secondary"
                startIcon={<MdOutlineFileDownload />}
                onClick={() => onDocumentDownload(doc)}
              >
                Download
              </Button>
              <Button
                size="small"
                className="text-secondary"
                startIcon={<MdOutlineVisibility />}
                onClick={() => onDocumentView(doc)}
              >
                Preview
              </Button>
            </CardActions>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}

export default DocsGridView;
